import React from "react";
import { useAccentColor } from "utils/accent-color";
import { formatEyebrowNumber } from "./knowledge-filters";

const ChapterCard = ({ chapter, number, onOpen, compact = false }) => {
  const accent = useAccentColor(chapter.color_code);
  const total = chapter.articles?.length || 0;
  const read = (chapter.articles || []).filter((a) => a.viewer_state?.has_viewed).length;
  const pct = total ? Math.round((read / total) * 100) : 0;

  return (
    <button
      type="button"
      onClick={() => onOpen(chapter.id)}
      className="flex flex-col text-left rounded-lg border border-border bg-surface p-4 sm:p-5 cursor-pointer w-full"
    >
      <div className="flex items-start gap-3.5">
        <div
          className="flex-shrink-0 w-10 h-10 rounded-md flex items-center justify-center font-mono text-sm font-bold"
          style={{ backgroundColor: accent.fill, color: accent.text }}
        >
          {formatEyebrowNumber(number)}
        </div>
        <div className="min-w-0 flex-1">
          <h3 className="text-[15px] font-bold text-text_primary leading-snug">{chapter.title}</h3>
          {!compact && chapter.description && (
            <p className="text-[12.5px] text-text_secondary leading-relaxed line-clamp-2 mt-1">
              {chapter.description}
            </p>
          )}
        </div>
      </div>

      <div className="mt-4 flex items-center justify-between font-mono text-[11px] text-text_muted">
        <span>
          {total} article{total === 1 ? "" : "s"}
        </span>
        <span style={{ color: accent.text }}>
          {read} / {total} read
        </span>
      </div>
      <div className="mt-2 h-1 rounded-full bg-surface_alt overflow-hidden">
        <div className="h-full rounded-full" style={{ width: `${pct}%`, backgroundColor: accent.base }} />
      </div>
    </button>
  );
};

export default ChapterCard;
